import React from "react";
import CardPreguntasFrecuentes from "./components/CardPreguntasFrecuentes";

function PreguntasFrecuentesComponent() {
  const dataPreguntas = [
    {
      title: "¿Qué necesito para acabar el curso?", description: "Debes haber realizado al menos una evaluación por cada unidad y contar con un promedio aprobatorio, es decir, de al menos 13 puntos. Todo esto, antes de que venza el curso.", video: false
    },
    {
      title: "Si no entiendo el contenido ¿a quién debo contactar?", description: "Recuerda que en cada curso encontrarás un especialista que estara atento a todas tus consultas, solo debe escribirle en el chat.", video: false
    },
    {
      title: "¿Cómo puedo comunicarme con un profesor?", description: "https://vimeo.com/511279702/50a49bb850", video: true
    },
    {
      title: "¿Para qué me sirve el certificado?", description: " ¡Lo más importante será todo lo que aprenderás! El certificado a  nombre de Zegel será la evidencia de que has desarrollado nuevas capacidades que potenciarán tu CV.", video: false
    }, {
      title: "Aprende cómo desarrollar una evaluación", description: "https://vimeo.com/511279750/f8ab65896a", video: true
    }
  ]

  return (
    <div className="border rounded-9 shadow paddingTop07 p-3 p-md-4 mb-4 mb-md-4 movilBackgroundPreguntas  cardTabs cardmr" >
      <h2 className="subtitleZegel ml-2" data-v-48f3e599="">
        Preguntas frecuentes
      </h2>
      <div className="p-fluid formgrid gridPreguntas">
        {
          dataPreguntas.map((item, index) => {
            return (
              <CardPreguntasFrecuentes title={item.title} description={item.description} video={item.video} />
            )
          })
        }
      </div>
    </div>
  );
}

export default PreguntasFrecuentesComponent;
